import { Box, Button, Grid, Typography } from "@mui/material";
import {
    EmailFieldRHF,
    EnhancedButtonPrimeReact,
    EnhancedButtonPrimeReactSeverity,
    EnhancedDropDownRHFWithLabel,
    LabelPosition,
    RHookFormPasswordFieldWithLabel,
    RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";

interface IHumanityApiSettingsInfoFieldsPanel {
    handleImportClick: (tag: string) => void
}

export const HumanityApiSettingsInfoFieldsPanel: FC<
    IHumanityApiSettingsInfoFieldsPanel
> = ({ handleImportClick }) => {
    return (
        <>
            <EmailFieldRHF
                label="Email"
                id="login"
                testId={`humanity-login`}
                labelPosition={LabelPosition.Top}
                labelColumns={4}
                fieldColumns={8}
            // required
            />
            <RHookFormPasswordFieldWithLabel
                id="password"
                testId={`password`}
                label="Password"
                labelPosition={LabelPosition.Top}
            // required
            />
            <RHookFormTextFieldWithLabel
                label="Key"
                id="key"
                testId={`key`}
                labelPosition={LabelPosition.Top}
            />
            <EnhancedDropDownRHFWithLabel
                selectName={"employees_mapping"}
                items={[
                    { label: "Employee Name", value: 100 },
                    { label: "Custom ID", value: 200 },
                ]}
                label={"Employees Mapping"}
                selectedItem={100}
                testId={"employees-mapping-ddl"}
            />
            <EnhancedButtonPrimeReact
                label="Save"
                raised
                severity={EnhancedButtonPrimeReactSeverity.Success}
                // loading={isImporting}
                onClickHandler={() => handleImportClick("humanity_api_settings")}
            />
        </>
    );
};